<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'
	
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'
	
	import {
			formatDate
		} from '@/utils/date'

	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				"templateData": templateData,
				spNo: null,
				templateId: ""
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			
			stringUtils.setDeleteIsShow(false);
			stringUtils.setAddIsShow(false);
			this.spNo = this.$route.query.spNo;
			this.templateId = this.$route.query.templateId;
			this.getTemplate();
		},
		created() {
		},
		methods: { //方法
			
			getTemplate:async function() {
				let that = this;
				// console.log(stringUtils.GetQueryString("templateId"))
				await getTemplateInfo(that.templateId).then(async res => {
					if (res == null || res.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "电话号码"||that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= 6 ? 1 : 2;
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						}
					}
					that.templateData = await that.assignControlBySpNo(that.templateData, that.spNo);
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val, name) {
				var type = "";
				var y = 0;
				var children = "";
				if (name == "申报类型") {
					var controls = this.templateData.TemplateContent.Controls;
					for (var i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == name) {
							var options = controls[i].Config.Selector.Options;
							for (var j = 0; j < options.length; j++) {
								if (options[j].Key == val) {
									type = options[j].Value[0].Text;
								}
							}
						} else if (controls[i].Property.Title[0].Text == "购房申请") {
							if (type == "购房申请") {
								// controls[i].IsShow = true;
								this.$set(controls[i], 'IsShow', true)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
									children[y].Property.Require = 1;
								}
							} else if (type == "个人利益申报") {
								// controls[i].IsShow = false;
								this.$set(controls[i], 'IsShow', false)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
									children[y].Values = null;
									children[y].Property.Require = 0;
								}
							}
						}else if (controls[i].Property.Title[0].Text == "个人利益申报") {
							if (type == "个人利益申报") {
								// controls[i].IsShow = true;
								this.$set(controls[i], 'IsShow', true)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
									children[y].Property.Require = 1;
								}
							} else if (type == "购房申请") {
								// controls[i].IsShow = false;
								this.$set(controls[i], 'IsShow', false)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
									children[y].Values = null;
									children[y].Property.Require = 0;
								}
							}
						}
					}
				}
				this.$forceUpdate();
			},
			tableOperation(){
				this.$message.info("本页面不支持增删控件");
			},
			submit() {
				let that = this;
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				
				
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申报类型"})[0]
				var control1Text=control1.Config.Selector.Options.filter(t=>{return t.Key==control1.Value})[0].Value[0].Text;
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"内容："+control1Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var data = new Date();
				  var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				  var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				  var dateTime = data.getFullYear() + "-" + month + "-" + date;
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+dateTime,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					console.log(res);
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
